import IBean from '../beans/IBean'
import { isArray } from 'util'

/**
 * reader 基类
 */
export default class IReader {
    /**
     * 初始化Reader
     * @param {String} from 源坐标系
     * @param {String} to 目标坐标系
     */
    constructor(beanClassName, from, to) {
        this._beanClassName = beanClassName

        this._from = from
        this._to = to
    }

    /**
     * 检查可用性
     * @param {IBean} v
     */
    check(v) {
        return v instanceof this._beanClassName
    }

    /**
     * @api
     * 读取features
     * @param {IBean} value
     * @returns {Array}
     */
    async read(value) {
        if (this.check(value)) {
            const result = await this._read(value)

            // 未分组
            if (isArray(result)) {
                return {
                    geojson: result,
                    group: this.group(result)
                }
            }
            // 已经分组
            return result
        }
        throw 'unexpected value type'
    }

    /**
     * @description 内部实现的读取features
     * @interface
     * @protected
     * @param {IBean} value
     * @returns {Array}
     */
    async _read(value) {
        throw 'please implement this methods'
    }

    /**
     * 新建一个空的点线面分组
     */
    newEmptyGroup() {
        const point = [],
            line = [],
            polygon = []

        // 类型数据
        const ENUMS = {
            POINT: point,
            MULTIPOINT: point,
            LINESTRING: line,
            MULTILINESTRING: line,
            POLYGON: polygon,
            MULTIPOLYGON: polygon,
            toObject() {
                return { point, line, polygon }
            }
        }
        return ENUMS
    }

    /**
     * 通用点线面分组方法
     * @param {Array} features
     */
    group(features) {
        // 类型数据
        const enums = this.newEmptyGroup()

        // 分组
        features.forEach(f => {
            const type = f.geometry.type.toUpperCase()
            const ls = enums[type]
            ls && ls.push(f)
        })
        return enums.toObject()
    }
}
